<template>
    <div class="view">
        <div class="header">
            <vxe-form ref="formRef" :data="queryform" @submit="submitEvent">
                <vxe-form-item title="助记词/名称" field="MnemonicPhrase"  :item-render="{}">
                    <template #default="params">
                        <vxe-input v-model="queryform.MnemonicPhrase"></vxe-input>
                    </template>
                </vxe-form-item>
                
                <vxe-form-item align="center"  :item-render="{}">
                    <template #default>
                        <vxe-button type="submit" status="primary" content="查询"></vxe-button>
                       <vxe-button  status="success" @click="handleAdd" content="新增"></vxe-button>
                    </template>
                </vxe-form-item>
            </vxe-form>
        </div>
        <div class="content">
           
            <vxe-table stripe  :data="tableData" height="100%" max-height="100%" ref="tableRef"  :loading="loading" :cell-config="{ height: 30 }"
                :row-config="{ isCurrent: true, isHover: true }" >
                 <vxe-column type="seq" width="40"></vxe-column>
                <vxe-column  field="bh" title="客户编号" width="120"></vxe-column>
                <vxe-column field="khmc" title="客户名称" width="180" show-overflow></vxe-column>
                <vxe-column field="zjc" title="助记词" width="120"></vxe-column>
                <vxe-column field="lxr" title="联系人" width="100">
                    <template #default="{ row }">
                        {{ row.lxr || '-' }}
                    </template>
                </vxe-column>
                <vxe-column field="lxdh" title="联系电话" width="140">
                    <template #default="{ row }">
                        {{ row.lxdh && row.lxdh.trim() ? row.lxdh.trim() : '-' }}
                    </template>
                </vxe-column>
                <vxe-column field="ysk" title="应收款" width="130" align="right">
                    <template #default="{ row }">
                        <span :style="{ color: row.ysk > 0 ? '#F56C6C' : '#67C23A', fontWeight: 'bold' }">
                            {{ row.ysk ? row.ysk.toFixed(2) : '0.00' }}
                        </span>
                    </template>
                </vxe-column>
                <vxe-column field="se" title="税额" width="120" align="right">
                    <template #default="{ row }">
                        {{ row.se ? row.se.toFixed(2) : '0.00' }}
                    </template>
                </vxe-column>
                <vxe-column title="操作" width="180" fixed="right">
                    <template #default="{ row }">
                        <vxe-button mode="text" status="warning" @click="handleEdit(row)">编辑</vxe-button>
                        <vxe-button mode="text" status="danger" @click="handleDelete(row)">删除</vxe-button>
                    </template>
                </vxe-column>
            </vxe-table>
          
        </div>
    </div>
      <!-- 选择客户* -->
    <vxe-modal v-model="showModel" width="40vw" height="30vh" destroy-on-close :title="initialData.usefule+'客户'" > 

      <template #default>
       <addCustomerComp v-model:initialData="initialData" @submit="submitEvent" />
      </template>
    </vxe-modal>
</template>
<script setup>
import { ref, reactive, onMounted } from 'vue'
import request from '@/request/request'
import addCustomerComp from '@/components/addComp/addCustomerComp.vue'
import { VxeUI } from 'vxe-pc-ui'

const queryform = reactive({ MnemonicPhrase: '', })
const tableData = ref([])
const loading = ref(false)
const showModel = ref(false)
const initialData = ref({ usefule: '新增', Customer: {} })

// ✅ 正确：String 类型直接赋值

const submitEvent = async () => {
    showModel.value = false
    await query()
}
const handleAdd = () => {
    showModel.value = true
    initialData.value = { usefule: '新增', Customer: {} }
 
}
const handleDelete = async (row) => {
     // 1. 使用 await 等待用户点击确认或取消
    const confirmResult = await VxeUI.modal.confirm({
      title: '删除确认',
      // 2. 使用模板字符串正确显示单号
      content: `确定要删除 ${row.khmc} 这个客户吗？`,
      mask: false,
      lockView: false
    });

    // 3. 判断用户是否点击了“确认”（vxe-table 通常返回 'confirm'）
    if (confirmResult === 'confirm') {
  
        try {
            loading.value = true
            let res = await request.delete(`/LinkMan/Delete?id=${row.id}`)
            if (res.success) {
                VxeUI.modal.message({ content: res.message, status: 'success' })
                await query()
            }
            loading.value = false
        } catch (error) {
            loading.value = false
            alert(error)
        }
    }
}
const handleEdit = (row) => {
    showModel.value = true
    initialData.value = { usefule: '修改', Customer: row }
}
const query = async () => {
    try {
        loading.value = true
        if (queryform.MnemonicPhrase === '') {
            let res = await request.get('/LinkMan/GetAllLinkman')
            tableData.value = res.data
        } else {
            let res = await request.get(`/LinkMan/GetLinkman?keyword=${queryform.MnemonicPhrase}`)
            tableData.value = res.data
        }
        loading.value = false
    } catch (error) {
        loading.value = false
        alert(error)
    }

}
onMounted(async() => {
    
    await query()
})
const tableRef = ref(null)

</script>
<style scoped>
.view {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.content {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    margin:10px;
}
</style>